// Single re-export barrel for every shared primitive the Effort page consumes.
//
// The page imports ONLY from here, so switching from these interim placeholders
// to the real kit is one edit per line in this file — no page or component churn.
//
// (1) Existing shared repo primitives (real, not placeholders): formatters,
//     empty/error states, skeletons. Re-mapped straight through.
// (2) Kit components (canonical in hub/kit/ as of Epic 1): Sentence,
//     SituationCard, NotPermitted, ClientSlideOut, DrillSheet, Timeline,
//     Composer. Re-exported from the kit so both hub and effort share the same
//     source (guard-tested in hub/_shims/__tests__/import-surface.test.js).
// (3) ErrorBoundary: consolidated onto shared/PanelErrorBoundary (Epic 1 S1.9).

// ── (1) Existing shared repo primitives ──────────────────────────────────────
export { EmptyState, ErrorState } from '../../../shared/StateMessage';
export { SkeletonDashboard, SkeletonAlert, RefetchBar } from '../../../shared/Skeleton';
export {
  fmtCurrency, fmtDuration, fmtDurationHM, fmtClock, fmtTimeOfDay, fmtDate, fmtDateLabel, fmtNumber,
  formatWhen, formatDue,
} from '../../../shared/format';
import { fmtCurrency } from '../../../shared/format';
export const fmtCost = (cost) => (cost == null ? '—' : fmtCurrency(cost));

// ── (2) Kit components (canonical in hub/kit/) ──────────────────────────────
export { default as SituationCard } from '../../kit/SituationCard';
export { default as Sentence } from '../../kit/Sentence';
export { default as NotPermitted } from '../../kit/NotPermitted';
export { default as ClientSlideOut } from '../../kit/ClientSlideOut';
export { default as DrillSheet } from '../../kit/DrillSheet';
export { default as Timeline } from '../../kit/Timeline';
export { default as Composer } from '../../kit/Composer';

// ── (3) ErrorBoundary — consolidated onto shared/PanelErrorBoundary ─────────
export { default as ErrorBoundary } from '../../../shared/PanelErrorBoundary';
